import React from "react";
import { Suspense, useEffect, useState, useCallback, useRef } from "react";
import { BrowserRouter, Route, Routes, Navigate, useNavigate, useLocation } from "react-router-dom";
import Loader from "../Layout/Loader";
import { authRoutes } from "./AuthRoutes";
import LayoutRoutes from "../Route/LayoutRoutes";
import Signin from "../Auth/Signin";
import PrivateRoute from "./PrivateRoute";
import { classes } from "../Data/Layouts";
import ScreenSaver from "../Components/ScreenSaver/ScreenSaver";
//import ScreenSaver2 from "../Components/ScreenSaver2/ScreenSaver2";
import ScreenSaver3 from "../Components/ScreenSaver3/ScreenSaver3";
import ScreenSaver4 from "../Components/ScreenSaver4/ScreenSaver4";
import ScreenSaver5 from "../Components/ScreenSaver5/ScreenSaver5";

// setup fake backend

// Componente para gerenciar inatividade
const InactivityManager = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const inactivityTimerRef = useRef(null);
  
  const INACTIVITY_TIME = 30000000; // 30 segundos de inatividade

  const resetInactivityTimer = useCallback(() => {
    
    if (inactivityTimerRef.current) {
      clearTimeout(inactivityTimerRef.current);
    }
    
    // Cria um novo timer
    inactivityTimerRef.current = setTimeout(() => {
      if (location.pathname !== `${process.env.PUBLIC_URL}/screensaver`) {
        navigate(`${process.env.PUBLIC_URL}/screensaver`);
      }
    }, INACTIVITY_TIME);
  }, [navigate, location.pathname]);

  useEffect(() => {
    const events = ['mousedown', 'mousemove', 'keypress', 'scroll', 'touchstart'];
    
    const handleActivity = () => {
      resetInactivityTimer();
    };

    // Adiciona os event listeners
    events.forEach(event => {
      document.addEventListener(event, handleActivity, true);
    });

    // Inicia o timer
    resetInactivityTimer();

    // Cleanup
    return () => {
      events.forEach(event => {
        document.removeEventListener(event, handleActivity, true);
      });
      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current);
      }
    };
  }, [resetInactivityTimer]);

  return children;
};

const Routers = () => {
  const login = useState(JSON.parse(localStorage.getItem("login")))[0];
  const [authenticated, setAuthenticated] = useState(false);
  const defaultLayoutObj = classes.find((item) => Object.values(item).pop(1) === "compact-wrapper");
  const layout = localStorage.getItem("layout") || Object.keys(defaultLayoutObj).pop();

  useEffect(() => {
    let abortController = new AbortController();
    setAuthenticated(JSON.parse(localStorage.getItem("authenticated")));
    console.ignoredYellowBox = ["Warning: Each", "Warning: Failed"];
    console.disableYellowBox = true;
    
  }, []);

  return (
    <BrowserRouter basename={"/"}>
      <InactivityManager>
          <Routes>


            {/* Rota do ScreenSaver */}
            <Route path={`${process.env.PUBLIC_URL}/screensaver`} element={<ScreenSaver />} />
            <Route exact path={`${process.env.PUBLIC_URL}/`} element={<Navigate to={`${process.env.PUBLIC_URL}/screensaver`} />} />

            
            {/* Rota do ScreenSaver2 */}
            {/*<Route path={`${process.env.PUBLIC_URL}/screensaver2`} element={<ScreenSaver2 />} />*/}  
            
            {/* Rota do ScreenSaver3 */}
            <Route path={`${process.env.PUBLIC_URL}/screensaver3`} element={<ScreenSaver3 />} />
            
            {/* Rota do ScreenSaver4 */}
            <Route path={`${process.env.PUBLIC_URL}/screensaver4`} element={<ScreenSaver4 />} />

            {/* Rota do ScreenSaver5 */}
            <Route path={`${process.env.PUBLIC_URL}/screensaver5`} element={<ScreenSaver5 />} />
            
            
            <Route exact path={`${process.env.PUBLIC_URL}`} element={<Navigate to={`${process.env.PUBLIC_URL}/presentation/eor/wag/Dubai`} />} />
            <Route exact path={`/`} element={<Navigate to={`${process.env.PUBLIC_URL}/presentation/eor/wag/Dubai`} />} />
            <Route path={`/*`} element={<LayoutRoutes />} />
            

          </Routes>
      </InactivityManager>
      
    </BrowserRouter>
  );
};

export default Routers;
